// import { Injectable } from "@angular/core";

// import { BehaviorSubject } from "rxjs";
// import { JsonApiService } from "@app/core/services/json-api.service";

// const defaultUser = {
//   username: "Guest"
// }
// @Injectable()
// export class UserService {
//   public user$ = new BehaviorSubject({...defaultUser});

//   constructor(private jsonApiService: JsonApiService) {
//     this.jsonApiService.fetch("/user/login-info.json").subscribe(this.user$)
//   }

//   public logout(){
//     this.user$.next({...defaultUser})
//   }

// }

import { BehaviorSubject, Observable } from "rxjs";
import { JsonApiService } from "@app/core/services/json-api.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AlertifyService } from "./alertify.service";
import { Router } from "@angular/router";
import { User } from "../models/user";
import { environment } from "@env/environment";
import { UserProfileDto } from "../models/dto/userProfileDto";
import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";

const defaultUser = {
  username: "Guest",
};
@Injectable()
export class UserService {
  public user$ = new BehaviorSubject({ ...defaultUser });

  private API_URL = environment.API_URL;
  private token = localStorage.getItem("token");

  constructor(
    private jsonApiService: JsonApiService,
    private httpClient: HttpClient,
    private alertifyService: AlertifyService,
    private router: Router,
    private authService: AuthService
  ) {
    this.jsonApiService.fetch("/user/login-info.json").subscribe(this.user$);
  }

  public logout() {
    this.user$.next({ ...defaultUser });
  }

  getUserById(userId) {
    let headers = new HttpHeaders();

    headers.append("Authorization", "Bearer " + this.token);

    return this.httpClient.get<UserProfileDto>(
      this.API_URL + "Users/detail?id=" + userId,
      { headers }
    );
  }

  edit(user, id) {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    headers = headers.append("Authorization", "Bearer " + this.token);
    this.httpClient
      .post(this.API_URL + "Users/profile", user, { headers: headers })
      .subscribe((data) => {
        this.alertifyService.success(
          "Profile kaydınız başarıyla düzenlenmiştir."
        );
        this.router.navigateByUrl("/");
      });
  }

  changePassword(changePasswordDto) {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    headers = headers.append("Authorization", "Bearer " + this.token);

    this.httpClient
      .post(this.API_URL + "Users/ChangePassword", changePasswordDto, {
        headers: headers,
      })
      .subscribe(
        (data) => {
          this.alertifyService.success("Şifreniz başarıyla düzenlenmiştir.");
          this.authService.logOut();
        },
        (error) => {
          this.alertifyService.error("Şifre hatalı");
        }
      );
  }
}
